
import { css } from 'lit';
export default css`
.search-hero__overlay {
  background-color: transparent;
}
  .search-hero__overlay {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .search-hero__overlay--show {
      display: block;
    }
  @media (min-width: 1024px) {
  .search-hero__overlay {
      z-index: 199
  }
    }
  .search-hero__header {
  padding-bottom: 1rem;
}
  @media (min-width: 768px) {
  .search-hero__header {
    padding-bottom: 2rem;
  }
}
  .search-hero__search-text {
  padding-bottom: 1rem;
}
  .search-hero__help-text {
  font-weight: 700;
}
  .search-hero__help-text {
    font-size: 18px;
    line-height: 22px;
    margin-bottom: 16px;
  }
  @media (min-width: 360px) {
  .search-hero__help-text {
      margin-top: 24px
  }
    }
  @media (min-width: 768px) {
  .search-hero__help-text {
      display: none
  }
    }
  .search-hero__input {
  position: relative;
}
  .search-hero__input {
  width: 100%;
}
  @media (min-width: 768px) {
  .search-hero__input {
    display: flex;
  }
}
  @media (min-width: 768px) {
  .search-hero__input {
    flex-direction: row;
  }
}
  @media (min-width: 768px) {
  .search-hero__input {
    justify-content: flex-start;
  }
}
  .search-hero__input-textfield {
  width: 100%;
}
  .search-hero__input-textfield {
  border-bottom-width: 1px;
}
  .search-hero__input-textfield {
  --tw-border-opacity: 1;
  border-color: rgba(164, 167, 171, var(--tw-border-opacity));
}
  .search-hero__input-textfield {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
  .search-hero__input-textfield {
  padding-left: 1rem;
}
  .search-hero__input-textfield {
  font-size: 1.125rem;
}
  .search-hero__input-textfield {
  --tw-text-opacity: 1;
  color: rgba(35, 35, 35, var(--tw-text-opacity));
}
  .search-hero__input-textfield::-moz-placeholder {
  font-size: 1.125rem;
}
  .search-hero__input-textfield:-ms-input-placeholder {
  font-size: 1.125rem;
}
  .search-hero__input-textfield::placeholder {
  font-size: 1.125rem;
}
  .search-hero__input-textfield::-moz-placeholder {
  font-style: italic;
}
  .search-hero__input-textfield:-ms-input-placeholder {
  font-style: italic;
}
  .search-hero__input-textfield::placeholder {
  font-style: italic;
}
  .search-hero__input-textfield::-moz-placeholder {
  --tw-text-opacity: 1;
  color: rgba(35, 35, 35, var(--tw-text-opacity));
}
  .search-hero__input-textfield:-ms-input-placeholder {
  --tw-text-opacity: 1;
  color: rgba(35, 35, 35, var(--tw-text-opacity));
}
  .search-hero__input-textfield::placeholder {
  --tw-text-opacity: 1;
  color: rgba(35, 35, 35, var(--tw-text-opacity));
}
  .search-hero__input-submit {
  position: absolute;
}
  @media (min-width: 768px) {
  .search-hero__input-submit {
    position: relative;
  }
}
  @media (min-width: 768px) {
  .search-hero__input-submit {
    right: 0px;
  }
}
  @media (min-width: 768px) {
  .search-hero__input-submit {
    top: 0px;
  }
}
  @media (min-width: 768px) {
  .search-hero__input-submit {
    display: block;
  }
}
  .search-hero__input-submit {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
}
  .search-hero__input-submit {
      top: 0;
      bottom: 0;
      right: 10px;
      font-size: 0;
      display: flex;
      align-items: center;
      z-index: 201;
    }
  @media (min-width: 768px) {
  .search-hero__input-submit {
        right: 0.5rem;
        font-size: 16px
    }
      }
  .search-hero__mobile-filters {
  display: flex;
}
  .search-hero__mobile-filters {
  cursor: pointer;
}
  .search-hero__mobile-filters {
  align-items: center;
}
  @media (min-width: 768px) {
  .search-hero__mobile-filters {
    display: none;
  }
}
  .search-hero__mobile-filters {
    margin-top: 9px;
  }
  .search-hero__mobile-filters-icon {
      width: 14px;
      margin-right: 5px;
    }
  .search-hero__input-wrapper {
  position: relative;
}
  .search-hero__input-wrapper {
  z-index: 200;
}
  .search-hero__input-wrapper {
  display: flex;
}
  .search-hero__input-wrapper {
  width: 100%;
}
  .search-hero__input-clear {
    cursor: pointer;
    width: 20px;
    height: 20px;
    position: absolute;
    bottom: 0;
    top: 0;
    margin: auto;
    right: 65px;
    display: none;
  }
  .search-hero__input-clear--show {
      display: block;
    }
  .search-hero__input-clear hf-icon {
      fill: #6b1F99;
    }
  .search-hero__input-clear hf-icon:hover {
  fill: currentColor;
}
  .search-hero__input-clear hf-icon:hover {
  --tw-text-opacity: 1;
  color: rgba(53, 25, 108, var(--tw-text-opacity));
}
  @media (min-width: 1024px) {
  .search-hero__input-clear {
      z-index: 300
  }
    }
  .search-hero__list-link {
  display: block;
}
  .search-hero__list-link {
  padding-top: 0.75rem;
}
  .search-hero__list-link {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
  .search-hero__list-link {
  text-decoration: underline;
}
  .search-hero__reset-link {
  margin-top: 0.5rem;
}
  .search-hero__reset-link {
  font-size: 1.125rem;
}
  .search-hero__modal-title {
  position: absolute;
}
  .search-hero__modal-title {
  text-align: center;
}
  .search-hero__modal-title {
  font-weight: 700;
}
  .search-hero__modal-title {
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}
  .search-hero__modal-title {
    font-size: 18px;
    top: -40px;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    padding: 0 17px;
  }
  .search-hero__modal-title-icon {
    width: 14px;
    margin-right: 5px;
  }
  .search-hero__offleft {
    position: absolute;
    left: -9999px;
  }
`;